<template>
	<div id="packs-page">

		<section class="container oversized-container my-2 content-section">
			<div class="row">
				<div class="col-12 col-title-s1">
					<h3 class="title">Paquete Casa</h3>

					<open-pay-charge ref="openPayModal" />

					<p>
						Selecciona alguno de nuestros paquetes Skycel para tu hogar.
					</p>
				</div>

				<offers-slider class="col-12 col-carousel" oferta-tipo="planCasa" />

			</div>
		</section>
		
	</div>
</template>

<script>
import offersSlider from "../daniel/offers-slider.vue"

	export default 
  	{
		components: { offersSlider },
	};
</script>